import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from '~/hooks'
import { useTheme } from 'styled-components'
import { LOCALES } from '~/locales'
import { Props } from './types'

const ellipsisText = (str: string, num = 100): string => {
  return `${str.substring(0, num - 1)}...`
}

const FoldText: React.FC<Props> = ({ texts }) => {
  const { isMobile } = useBreakpoint()
  const { i18n, t } = useTranslation()
  const isZh = i18n.resolvedLanguage === LOCALES.ZH
  const theme = useTheme()

  const [textFold, setTextFold] = useState(true)

  const isDescFold = isMobile && textFold

  return (
    <span>
      {isDescFold
        ? ellipsisText(texts[0], isZh ? 50 : 100)
        : texts.map((text, idx) => {
            return [
              <span key={`text-${idx}`}>{text}</span>,
              idx === texts.length - 1 ? null : <br key={`br-${idx}`} />,
            ]
          })}
      {isMobile && (
        <span
          style={{ color: theme.colors.primary }}
          onClick={() => setTextFold(!textFold)}
        >
          {t(isDescFold ? 'unfold' : 'fold')}
        </span>
      )}
    </span>
  )
}

export default FoldText
